import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        // Use your neutral color for skeleton background
        "bg-(--neutral-200) animate-pulse rounded-md",
        className
      )}
      {...props} />
  );
}

export { Skeleton }